import { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from 'reactstrap';
import { isApiError } from '../../api/errors';
import { useSuspendUser } from './userMutations';

const REASON_CODES = [
  { value: 'fraud', label: 'Betrugsverdacht' },
  { value: 'chargeback', label: 'Wiederholte Chargebacks' },
  { value: 'tos_violation', label: 'AGB-Verstoß' },
  { value: 'spam', label: 'Spam-Aktivität' },
  { value: 'customer_request', label: 'Kundenwunsch' },
  { value: 'other', label: 'Sonstiges' },
];

export function SuspendUserDialog({ isOpen, user, onClose }) {
  const [reasonCode, setReasonCode] = useState('tos_violation');
  const [reasonNote, setReasonNote] = useState('');
  const [error, setError] = useState(null);
  const suspend = useSuspendUser();

  if (!user) return null;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await suspend.mutateAsync({
        id: user.id,
        reasonCode,
        reasonNote: reasonNote.trim() || undefined,
      });
      setReasonCode('tos_violation');
      setReasonNote('');
      onClose();
    } catch (err) {
      setError(isApiError(err) ? err.message : 'Sperren fehlgeschlagen.');
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={suspend.isPending ? undefined : onClose} backdrop="static">
      <ModalHeader toggle={suspend.isPending ? undefined : onClose}>
        Benutzer sperren · #{user.id}
      </ModalHeader>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <Alert color="warning" className="small">
            Der Benutzer kann sich nicht mehr einloggen, bis ein Operator die Sperre
            aufhebt. Aktive Subscriptions bleiben bestehen.
          </Alert>
          <FormGroup>
            <Label>Reason-Code</Label>
            <Input type="select" value={reasonCode} onChange={(e) => setReasonCode(e.target.value)}>
              {REASON_CODES.map((r) => (
                <option key={r.value} value={r.value}>
                  {r.label}
                </option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label>Notiz <span className="text-muted">(optional)</span></Label>
            <Input
              type="textarea"
              rows={3}
              value={reasonNote}
              onChange={(e) => setReasonNote(e.target.value)}
              placeholder="Interne Notiz für den Audit-Log"
              maxLength={500}
            />
          </FormGroup>
          {error && <Alert color="danger">{error}</Alert>}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={onClose} disabled={suspend.isPending}>
            Abbrechen
          </Button>
          <Button color="warning" type="submit" disabled={suspend.isPending}>
            {suspend.isPending ? 'Sperren…' : 'Sperren'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}
